import { render, staticRenderFns } from "./_newProduct.vue?vue&type=template&id=40bb5160"
import script from "./_newProduct.vue?vue&type=script&lang=js"
export * from "./_newProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports